import React, { useState, useEffect, useContext, useRef } from 'react';
import { Modal } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import Image from '../common/image';
import shubham_removebg from "../../assest/images/shubham_removebg.png"
import { ToastContainer, toast } from 'react-toastify';
import './Login.css';
import axios from 'axios';
import config from "../../envconfig";
import { UserContext } from '../common/UserContext';
import Cookies from "js-cookie";
import { encryptUrl, decryptUrl } from "../common/cryptoUrl";

const Login = (props) => {
  const navigate = useNavigate();
  const [logoSrc, setLogoSrc] = useState(null);  // <-- for backend logo
  console.log("API_URL", config)
  const [formData, setFormData] = useState({
    CM_CompanyCode: '',
    UM_UserCode: '',
    UM_Password: ''
  });
  const { CompanyCode } = useParams();
  console.log("PARAM CompanyCode:", CompanyCode);
  const [message, setMessage] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [UM_GroupId, setUM_GroupId] = useState(null); // State to store UM_GroupId
  const [UM_CompanyGrpID, setUM_CompanyGrpID] = useState(null);
  const [UM_DefaultSCPId, setUM_DefaultSCPId] = useState(null);
  const [UM_UserId, setUM_UserId] = useState(null);
  const [UM_UserCode, setUM_UserCode] = useState(null);
  const [UM_CompanyID, setUM_CompanyID] = useState(null);
  const [isPwdExpired, setIsPwdExpired] = useState(false);
  const [pwdExpiryMsg, setPwdExpiryMsg] = useState('');


  const [resetSuccess, setResetSuccess] = useState(false);
  const [changePassword, setChangePassword] = useState(false);
  const [newPasswordError, setNewPasswordError] = useState(false);
  const [confirmPasswordError, setConfirmPasswordError] = useState(false);
  const [errors, setErrors] = useState({
    CM_CompanyCode: '',
    UM_UserCode: '',
    UM_Password: '',
    // Other fields' errors here
  });
  // Initial state setup
  const initialState = {
    UM_UserCode: '',
    UM_Password: ''
  };
  const [data1, setdata1] = useState();
  const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility
  const [showPopup, setShowPopup] = useState(false);
  const { setGroupID, setUserId, setCompanyID, setCompanyGrpID, setUserCode, setDefaultId, setuserType, setUM_UserType, setUM_DisplayName } = useContext(UserContext);

  let UserId = UM_UserId;
  let GroupId = UM_GroupId;
  let CompanyID = UM_CompanyID;
  let CompanyGrpID = UM_CompanyGrpID;
  let UserCode = UM_UserCode;
  let DefaultSCPId = UM_DefaultSCPId;

  const toastRef = useRef(null);
  const showToast = (type, message, options = {}) => {
    if (toastRef.current && toast.isActive(toastRef.current)) {
      toast.update(toastRef.current, {
        render: message,
        type,
        autoClose: 3000,
        ...options,
      });
    } else {
      toastRef.current = toast[type](message, {
        autoClose: 3000,
        ...options,
      });
    }
  };
  // fetch logo from backend
  useEffect(() => {
    const fetchLogo = async () => {
      try {
        const response = await axios.get(`${config.API_URL}/api/logo`, {
          responseType: "blob", // important for images
        });

        const url = URL.createObjectURL(response.data);
        setLogoSrc(url);
      } catch (error) {
        console.error("Error fetching logo:", error);
        // fallback: use static logo if backend not available
        setLogoSrc(require("../../assest/images/Logo.png"));
      }
    };

    fetchLogo();
  }, []);


  useEffect(() => {
    console.log("🔥 useEffect START", CompanyCode);

    if (!CompanyCode) return;

    let finalCode = CompanyCode;

    try {
      finalCode = decryptUrl(CompanyCode);
      console.log("✅ decryptUrl SUCCESS:", finalCode);
    } catch (err) {
      console.error("❌ decryptUrl FAILED:", err);
    }

    console.log("FINAL:", finalCode);

    setFormData(prev => {
      console.log("SETTING CM_CompanyCode TO:", finalCode);
      return {
        ...prev,
        CM_CompanyCode: finalCode
      };
    });
  }, [CompanyCode]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    setErrors(prev => ({
      ...prev,
      [name]: ''
    }));

    if (value.toLowerCase() === 'superadmin') {
      setChangePassword(false);
    }
  };



  useEffect(() => {
    // Function to get the UserName cookie value
    const getUserNameCookie = () => {
      const cookies = document.cookie.split('; ');
      for (const cookie of cookies) {
        const [name, value] = cookie.split('=');
        if (name === 'UserName') {
          return value;
        }
      }
      return null;
    };

    // Check for UserName cookie on component mount
    const userNameCookie = getUserNameCookie();
    if (userNameCookie) {
      // If the cookie exists, navigate to the dashboard
      navigate('/home');
    } else {
      console.log("UserName cookie does not exist");
    }
  }, [navigate]); // Include navigate in dependency array to avoid warning

  const audittrailpost = async (details) => {
    const getCurrentTimestamp = () => {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0'); // months are zero-indexed
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    const currentTimestamp = getCurrentTimestamp();
    const AUTR_OldValue = details?.AUTR_OldValue ?? null;
    const AUTR_NewValue = details?.AUTR_NewValue ?? null;
    const AUTR_Message = details.AUTR_Message;
    const AUTR_AuditType = details.AUTR_AuditType;
    const AUTR_ScreenName = details.AUTR_ScreenName;

    const data = {
      AUTR_ScreenName: AUTR_ScreenName,
      AUTR_OldValue: AUTR_OldValue,
      AUTR_NewValue: AUTR_NewValue,
      AUTR_Message: AUTR_Message,
      AUTR_UserID: UserId,
      AUTR_UserName: UserCode,
      AUTR_TimeStamp: currentTimestamp,
      AUTR_AuditType: AUTR_AuditType,
      AUTR_SCPID: DefaultSCPId,
      AUTR_CompanyGrpId: CompanyGrpID,
      AUTR_CompanyID: CompanyID,
      AUTR_CreatedBy: UserId,
      AUTR_CreatedDateTime: currentTimestamp
    };

    try {
      const response = await axios.post(`${config.API_URL}/api/audittrail`, data);
      console.log('Success:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    logAction('handleSubmit():started');


    let formIsValid = true;
    const newErrors = {};

    // UM_UserCode validation
    if (formData.UM_UserCode.trim() === '') {
      newErrors.UM_UserCode = '*';
      formIsValid = false;
    }

    // UM_Password validation
    if (formData.UM_Password.trim() === '') {
      newErrors.UM_Password = '*';
      formIsValid = false;
    }

    console.log("Using CompanyCode from params:", CompanyCode);

    // Company Code validation and assignment (only for non-SuperAdmin)
    if (formData.UM_UserCode !== "SuperAdmin" && formData.UM_UserCode !== "") {
      // If CM_CompanyCode is empty, try to use CompanyCode from params
      if (!formData.CM_CompanyCode || formData.CM_CompanyCode.trim() === '') {
        if (CompanyCode && CompanyCode.trim() !== '') {
          // Use CompanyCode from params
          setFormData(prev => ({
            ...prev,
            CM_CompanyCode: CompanyCode
          }));
          console.log("Using CompanyCode from params:", CompanyCode);
        } else {
          // Both are empty - show error
          showToast('error', `Company Code is required.`);
          formIsValid = false;
        }
      }
    }

    // 🔴 If validation fails → stop here
    if (!formIsValid) {
      setErrors(newErrors);
      return;
    }

    // ✅ Clear errors if valid
    setErrors({});

    try {
      // 🔐 LOGIN API
      const response = await fetch(`${config.API_URL}/Login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      const data = await response.json();
      console.log("formData.UM_UserCode", formData.UM_UserCode, "data.UM_CompanyID", data.UM_CompanyID)

      if (!response.ok || !data.success) {
        showToast('error', data.error || 'Invalid credentials');
        logAction(`Login failed: ${data.error}`, true);
        return;
      }
      // 🔹 Store user data
      setUM_GroupId(data.UM_GroupId);
      setUM_CompanyGrpID(data.UM_CompanyGrpID);
      setUM_UserId(data.UM_UserId);
      setUM_UserType(data.UM_UserType);
      setUM_UserCode(data.UM_UserCode);
      setUM_DisplayName(data.UM_DisplayName);
      setUM_DefaultSCPId(data.UM_DefaultSCPId);
      setUM_CompanyID(data.UM_CompanyID);

      setUserId(data.UM_UserId);
      setGroupID(data.UM_GroupId);
      setCompanyID(data.UM_CompanyID);
      setCompanyGrpID(data.UM_CompanyGrpID);
      setUserCode(data.UM_UserCode);
      setDefaultId(data.UM_DefaultSCPId);
      setUM_UserType(data.UM_UserType);

      // ✅ SuperAdmin → Direct login
      if (formData.UM_UserCode === "SuperAdmin") {
        const sessionTO = data.sessiontimeout || 60;
        Cookies.set("TIME", sessionTO, { expires: sessionTO / 1440 });

        document.cookie = `UserName=SuperAdmin; path=/; max-age=${sessionTO * 60}`;

        if (CompanyCode && typeof CompanyCode === "string" && CompanyCode.trim() !== "") {
          document.cookie =
            `CM_CompanyCode=${encodeURIComponent(CompanyCode)}; ` +
            `expires=Fri, 31 Dec 9999 23:59:59 GMT; ` +
            `path=/; SameSite=Lax`;
        }
        console.log("formData.UM_UserCode", formData.UM_UserCode, "data.UM_CompanyID", data.UM_CompanyID)

        navigate('/home');
        return;
      }

      // 🔄 Force password change (first login)
      const checkPwdChange = await fetch(
        `${config.API_URL}/checkPwdChange/${formData.UM_UserCode}/${data.UM_CompanyID}`
      );
      console.log("formData.UM_UserCode", formData.UM_UserCode, "data.UM_CompanyID", data.UM_CompanyID)
      if (checkPwdChange.ok) {
        const { UM_IsChangeNewPwd } = await checkPwdChange.json();
        if (UM_IsChangeNewPwd === 0) {
          setIsPwdExpired(false);   // ✅ CLEAR
          setPwdExpiryMsg('');     // ✅ CLEAR
          setShowModal(true);
          return;
        }
      }
      if (changePassword) {
        setIsPwdExpired(false);  // ✅ CLEAR
        setPwdExpiryMsg('');    // ✅ CLEAR
        setShowModal(true);
        return;
      }

      // 🔐 Password Expiry Check
      const expiryRes = await fetch(
        `${config.API_URL}/checkPasswordExpiry/${formData.UM_UserCode}/${data.UM_CompanyID}`
      );


      if (!expiryRes.ok) {
        logAction('Password expiry API failed', true);
        return;
      }
      const { flag, expiryDate } = await expiryRes.json();

      // 🔴 Password expired → RESET POPUP
      if (flag === 2) {
        setIsPwdExpired(true);
        setPwdExpiryMsg('Your password has expired. Please reset your password.');
        setShowModal(true);
        setShowPopup(false);
        return;
      }

      // 🟠 Expiring soon → WARNING POPUP
      if (flag === 1) {
        setPwdExpiryMsg(
          `Your password will expire on ${expiryDate}. Please change your password.`
        );
        setShowPopup(true);
        return;
      }

      // 🟢 Password valid → Continue login
      const apiUrl = `${config.API_URL}/check-session-timeout/${data.UM_UserId}`;
      const sessionRes = await axios.get(apiUrl);

      document.cookie =
        `CM_CompanyCode=${encodeURIComponent(CompanyCode)}; ` +
        `expires=Fri, 31 Dec 9999 23:59:59 GMT; ` +
        `path=/; SameSite=Lax`;

      const sessionTO = sessionRes.data[0].CITPM_SessionTimeOut;
      localStorage.setItem('session_timeout', sessionTO);

      Cookies.set("TIME", sessionTO, { expires: sessionTO / 1440 });
      document.cookie = `UserName=${data.UM_UserCode}; path=/; max-age=${sessionTO * 60}`;

      navigate('/home');

    } catch (error) {
      showToast('error', 'Something went wrong. Please try again.');
      logAction(`handleSubmit(): ${error}`, true);
    }

    logAction('handleSubmit():ended');
  };


  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   logAction('handleSubmit():started');

  //   let formIsValid = true;
  //   const newErrors = {};

  //   // UM_UserCode validation
  //   if (formData.UM_UserCode.trim() === '') {
  //     newErrors.UM_UserCode = '*';
  //     formIsValid = false;
  //   }

  //   // UM_Password validation
  //   if (formData.UM_Password.trim() === '') {
  //     newErrors.UM_Password = '*';
  //     formIsValid = false;
  //   }

  //   // Company Code validation and assignment (only for non-SuperAdmin)
  //   if (formData.UM_UserCode !== "SuperAdmin" && formData.UM_UserCode !== "") {
  //     // If CM_CompanyCode is empty, try to use CompanyCode from params
  //     if (!formData.CM_CompanyCode || formData.CM_CompanyCode.trim() === '') {
  //       if (CompanyCode && CompanyCode.trim() !== '') {
  //         // Use CompanyCode from params
  //         setFormData(prev => ({
  //           ...prev,
  //           CM_CompanyCode: CompanyCode
  //         }));
  //         console.log("Using CompanyCode from params:", CompanyCode);
  //       } else {
  //         // Both are empty - show error
  //         showToast('error', `Company Code is required.`);
  //         formIsValid = false;
  //       }
  //     }
  //   }

  //   // 🔴 If validation fails → stop here
  //   if (!formIsValid) {
  //     setErrors(newErrors);
  //     return;
  //   }

  //   // ✅ Clear errors if valid
  //   setErrors({});

  //   // Prepare the final form data for API call
  //   const finalFormData = { ...formData };

  //   // For non-SuperAdmin users, ensure CM_CompanyCode is set
  //   if (formData.UM_UserCode !== "SuperAdmin" && formData.UM_UserCode !== "") {
  //     if (!finalFormData.CM_CompanyCode || finalFormData.CM_CompanyCode.trim() === '') {
  //       finalFormData.CM_CompanyCode = CompanyCode;
  //     }
  //   }

  //   try {
  //     // 🔐 LOGIN API - Use finalFormData instead of formData
  //     const response = await fetch(`${config.API_URL}/Login`, {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify(finalFormData), // Use finalFormData here
  //     });
  //     const data = await response.json();
  //     console.log("formData.UM_UserCode", finalFormData.UM_UserCode, "data.UM_CompanyID", data.UM_CompanyID)

  //     if (!response.ok || !data.success) {
  //       showToast('error', data.error || 'Invalid credentials');
  //       logAction(`Login failed: ${data.error}`, true);
  //       return;
  //     }

  //     // Rest of your code remains the same...
  //     // 🔹 Store user data
  //     setUM_GroupId(data.UM_GroupId);
  //     setUM_CompanyGrpID(data.UM_CompanyGrpID);
  //     setUM_UserId(data.UM_UserId);
  //     setUM_UserType(data.UM_UserType);
  //     setUM_UserCode(data.UM_UserCode);
  //     setUM_DisplayName(data.UM_DisplayName);
  //     setUM_DefaultSCPId(data.UM_DefaultSCPId);
  //     setUM_CompanyID(data.UM_CompanyID);

  //     setUserId(data.UM_UserId);
  //     setGroupID(data.UM_GroupId);
  //     setCompanyID(data.UM_CompanyID);
  //     setCompanyGrpID(data.UM_CompanyGrpID);
  //     setUserCode(data.UM_UserCode);
  //     setDefaultId(data.UM_DefaultSCPId);
  //     setUM_UserType(data.UM_UserType);

  //     // ✅ SuperAdmin → Direct login
  //     if (finalFormData.UM_UserCode === "SuperAdmin") {
  //       const sessionTO = data.sessiontimeout || 60;
  //       Cookies.set("TIME", sessionTO, { expires: sessionTO / 1440 });

  //       document.cookie = `UserName=SuperAdmin; path=/; max-age=${sessionTO * 60}`;

  //       if (CompanyCode && typeof CompanyCode === "string" && CompanyCode.trim() !== "") {
  //         document.cookie =
  //           `CM_CompanyCode=${encodeURIComponent(CompanyCode)}; ` +
  //           `expires=Fri, 31 Dec 9999 23:59:59 GMT; ` +
  //           `path=/; SameSite=Lax`;
  //       }
  //       console.log("finalFormData.UM_UserCode", finalFormData.UM_UserCode, "data.UM_CompanyID", data.UM_CompanyID)

  //       navigate('/home');
  //       return;
  //     }

  //     // 🔄 Force password change (first login)
  //     const checkPwdChange = await fetch(
  //       `${config.API_URL}/checkPwdChange/${finalFormData.UM_UserCode}/${data.UM_CompanyID}`
  //     );
  //     console.log("finalFormData.UM_UserCode", finalFormData.UM_UserCode, "data.UM_CompanyID", data.UM_CompanyID)

  //     if (checkPwdChange.ok) {
  //       const { UM_IsChangeNewPwd } = await checkPwdChange.json();
  //       if (UM_IsChangeNewPwd === 0) {
  //         setIsPwdExpired(false);   // ✅ CLEAR
  //         setPwdExpiryMsg('');     // ✅ CLEAR
  //         setShowModal(true);
  //         return;
  //       }
  //     }

  //     if (changePassword) {
  //       setIsPwdExpired(false);  // ✅ CLEAR
  //       setPwdExpiryMsg('');    // ✅ CLEAR
  //       setShowModal(true);
  //       return;
  //     }

  //     // 🔐 Password Expiry Check
  //     const expiryRes = await fetch(
  //       `${config.API_URL}/checkPasswordExpiry/${finalFormData.UM_UserCode}/${data.UM_CompanyID}`
  //     );

  //     if (!expiryRes.ok) {
  //       logAction('Password expiry API failed', true);
  //       return;
  //     }
  //     const { flag, expiryDate } = await expiryRes.json();

  //     // 🔴 Password expired → RESET POPUP
  //     if (flag === 2) {
  //       setIsPwdExpired(true);
  //       setPwdExpiryMsg('Your password has expired. Please reset your password.');
  //       setShowModal(true);
  //       setShowPopup(false);
  //       return;
  //     }

  //     // 🟠 Expiring soon → WARNING POPUP
  //     if (flag === 1) {
  //       setPwdExpiryMsg(
  //         `Your password will expire on ${expiryDate}. Please change your password.`
  //       );
  //       setShowPopup(true);
  //       return;
  //     }

  //     // 🟢 Password valid → Continue login
  //     const apiUrl = `${config.API_URL}/check-session-timeout/${data.UM_UserId}`;
  //     const sessionRes = await axios.get(apiUrl);

  //     document.cookie =
  //       `CM_CompanyCode=${encodeURIComponent(finalFormData.CM_CompanyCode || CompanyCode)}; ` +
  //       `expires=Fri, 31 Dec 9999 23:59:59 GMT; ` +
  //       `path=/; SameSite=Lax`;

  //     const sessionTO = sessionRes.data[0].CITPM_SessionTimeOut;
  //     localStorage.setItem('session_timeout', sessionTO);

  //     Cookies.set("TIME", sessionTO, { expires: sessionTO / 1440 });
  //     document.cookie = `UserName=${data.UM_UserCode}; path=/; max-age=${sessionTO * 60}`;

  //     navigate('/home');

  //   } catch (error) {
  //     showToast('error', 'Something went wrong. Please try again.');
  //     logAction(`handleSubmit(): ${error}`, true);
  //   }

  //   logAction('handleSubmit():ended');
  // };
  const validatePassword = (password) => {
    const errors = [];

    const hasUpper = /[A-Z]/.test(password);
    const hasLower = /[a-z]/.test(password);
    const hasNumber = /\d/.test(password);
    const hasSpecial = /[@$!%*#?&]/.test(password);
    const hasValidLength = password.length >= 8 && password.length <= 12;

    if (!hasValidLength) errors.push("length");
    if (!hasUpper) errors.push("upper");
    if (!hasLower) errors.push("lower");
    if (!hasNumber) errors.push("number");
    if (!hasSpecial) errors.push("special");

    // 👉 Multiple missing
    if (errors.length > 1) {
      return {
        valid: false,
        message:
          "Password must contain : one uppercase letter, one lowercase letter, one number, one special character and between 8 to 12 characters in length."
      };
    }

    // 👉 Single missing (priority wise)
    if (!hasValidLength) {
      return { valid: false, message: "Password must be between 8 and 12 characters in length." };
    }
    if (!hasUpper) {
      return { valid: false, message: "Password must contain at least one uppercase letter." };
    }
    if (!hasLower) {
      return { valid: false, message: "Password must contain at least one lowercase letter." };
    }
    if (!hasNumber) {
      return { valid: false, message: "Password must contain at least one number." };
    }
    if (!hasSpecial) {
      return { valid: false, message: "Password must contain at least one special character." };
    }

    return { valid: true };
  };

  const handleReset = async (e) => {
    e.preventDefault();
    logAction('handleReset():started');

    // Reset error states
    setNewPasswordError(false);
    setConfirmPasswordError(false);

    // Check if both fields are empty
    if (!newPassword) {
      setNewPasswordError(true);
    }
    if (!confirmPassword) {
      setConfirmPasswordError(true);
    }
    if (!newPassword || !confirmPassword) {
      return
    }

    if (newPassword !== confirmPassword) {
      showToast('warning', "New Password and Confirm New Password do not match.");
      logAction('handleReset():Password reset failed: New Password and Confirm New Password do not match.', true);
      return;
    }
    const pwdCheck = validatePassword(newPassword);
    if (!pwdCheck.valid) {
      showToast('warning', pwdCheck.message);
      return;
    }
    try {
      const response = await fetch(
        `${config.API_URL}/updateUserPassword/${formData.UM_UserCode}/${UM_CompanyID}`,
        {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ UM_Password: newPassword })
        }
      );

      if (response.ok) {
        showToast('success', "Password set successfully.");

        const updateIsChangePwdResponse = await fetch(
          `${config.API_URL}/updateIsChangePwd/${formData.UM_UserCode}/${UM_CompanyID}`,
          {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ UM_IsChangeNewPwd: 1 })
          }
        );

        if (updateIsChangePwdResponse.ok) {
          const details = {
            AUTR_ScreenName: "Login",
            AUTR_Message: "PasswordReset Success - " + formData.UM_UserCode,
            AUTR_AuditType: 1
          };
          audittrailpost(details);
          logAction(`handleReset():Password set successfully for user ${formData.UM_UserCode}`);
          console.log("UM_IsChangeNewPwd updated successfully to 1");
        } else {
          logAction(`handleReset():Failed to update UM_IsChangeNewPwd for user ${formData.UM_UserCode}`, true);
          console.error("Failed to update UM_IsChangeNewPwd");
        }
        setShowModal(false);
        console.log("UM_UserCode:", UM_UserCode);
        setFormData({
          ...formData,
          UM_Password: ''  // Clear the password input field
        });
        setChangePassword(false);
        setConfirmPassword("");
        setNewPassword("");
      } else if (response.status === 400) {
        const errorMessage = await response.text(); // Extract error message from response body
        showToast('warning', errorMessage);
        logAction(errorMessage); // Display error message to the user
      } else {
        logAction(`handleReset():Password reset failed for user ${formData.UM_UserCode}`, true);
        console.error("Password reset failed");
      }
    } catch (error) {
      logAction(`handleReset():An error occurred during password reset for user ${formData.UM_UserCode}: ${error}`, true);
    }

    logAction('handleReset():ended');
  };

  const handleCancel = () => {
    setFormData(prev => ({
      // Preserve CM_CompanyCode from previous state
      CM_CompanyCode: prev.CM_CompanyCode,
      UM_UserCode: '',
      UM_Password: ''
    }));
    setErrors(initialState);
    setChangePassword(false);
  };
  // console.log("CM_CompanyCode", CM_CompanyCode)
  // Clear form data on successful reset
  if (resetSuccess) {
    console.log("UserName:", UM_UserCode);
    setFormData(prev => ({
      // Preserve CM_CompanyCode from previous state
      CM_CompanyCode: prev.CM_CompanyCode,
      UM_UserCode: '',
      UM_Password: ''
    }));

    setChangePassword(false);
    setResetSuccess(false); // Reset success status
  }

  const logAction = async (action, isError = false) => {
    console.log(`${isError ? '[ERROR] ' : ''}${action}`);
    try {
      const response = await fetch(`${config.API_URL}/api/log`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ module: "Login:", action, userCode: "User", isError }),
      });

      if (!response.ok) {
        throw new Error('Failed to log action');
      }
    } catch (error) {
      console.error('Error logging action:', error);
    }
  };
  const handleCloseModal = () => {
    UserId = UM_UserId;
    console.log("UserID : ", UserId)
    const apiUrl = `${config.API_URL}/check-session-timeout/` + UserId;
    // Make the HTTP GET request
    axios.get(apiUrl)
      .then(response => {
        const data = (response.data);
        let sessionTO = data[0]
        sessionTO = sessionTO.CITPM_SessionTimeOut;
        console.log("Session TimeOut : ", sessionTO)
        const sessiondata = {
          CITPM_SessionTimeOut: sessionTO,
          userID: UserId
        }

        const userName = UserCode; // Set this to the desired username value
        document.cookie =
        `CM_CompanyCode=${encodeURIComponent(CompanyCode)}; ` +
        `expires=Fri, 31 Dec 9999 23:59:59 GMT; ` +
        `path=/; SameSite=Lax`;

        document.cookie = `UserName=${userName}; path=/; max-age=${sessionTO * 60}`; // Cookie expires in the specified number of minutes

        // Check if the cookie was set successfully
        if (document.cookie.includes(`UserName=${userName}`)) {
          console.log("UserName cookie set:", userName);
          // Navigate to the dashboard
          navigate('/home');
        } else {
          console.log("Failed to set UserName cookie");
        }
      })
      .catch(error => {
        console.error('Error:', error.message);
      });
    setShowPopup(false);
  };

  return (
    <>
      <ToastContainer
        limit={1} />
      <div className='background'>
        <div className='container-1'>
          <div className='upper-container'>
            <div className='logo-Shubham'>
              {/* <Image src={shubham_removebg} alt="shubham_removebg" className="logo-img" /> */}
              <img src={logoSrc} alt="Company Logo" className="logo-img" />
            </div>
          </div>
          <form className='form-1' onSubmit={handleSubmit} autoComplete="off" >
            {/* 🔒 Dummy inputs to kill browser autofill */}
            <input
              type="text"
              name="fake_username"
              autoComplete="username"
              style={{ display: 'none' }}
            />

            <input
              type="password"
              name="fake_password"
              autoComplete="current-password"
              style={{ display: 'none' }}
            />


            <div className='Login-text'>
              <p className='Login-heading'>Login</p>

            </div>
            <div className='input-box'>
              <input
                type="input"
                placeholder='User Name'
                name='UM_UserCode'
                value={formData.UM_UserCode}
                onChange={handleInputChange}
                autoComplete="new-username" />
              {errors.UM_UserCode && <span className='loginerror' style={{ color: 'red' }}>{errors.UM_UserCode}</span>}
            </div>
            <div className='input-box'>
              <input
                type={showPassword ? "text" : "password"}
                placeholder='Password'
                name='UM_Password'
                className='password_input'
                value={formData.UM_Password}
                onChange={handleInputChange}
                autoComplete="new-password"
              />
              {errors.UM_Password && <span className='loginerror' style={{ color: 'red' }}>{errors.UM_Password}</span>}


            </div>
            <div className='change-password'>
              <input
                className='form-check-input'
                type='checkbox'
                checked={changePassword}
                onChange={(e) => setChangePassword(e.target.checked)}
                disabled={formData.UM_UserCode.toLowerCase() === 'superadmin'}
              />
              <label className='text-change-password'>CHANGE PASSWORD</label>
            </div>

            <div className='message-container'>{message && <span className='message'>{message}</span>}</div>
            <div className='buttonss'>
              <button disabled={showModal} type="submit" className='btnLogin button-spacing'>LOGIN</button>
              <button type='button' onClick={handleCancel} className='btnCancel button-spacing'>CANCEL</button>
            </div>
          </form>
        </div>

        <Modal size='md' centered show={showModal} backdrop="static" keyboard={false}
          dialogClassName="custom-modal-95"
          onHide={() => {
            setShowModal(false);
            setNewPassword(""); // Clear the new password field
            setConfirmPassword(""); // Clear the confirm password field
            setNewPasswordError(false); // Clear any error state
            setConfirmPasswordError(false); // Clear any error state
            // ✅ reset expiry state
            setIsPwdExpired(false);
            setPwdExpiryMsg('');
          }}>
          <Modal.Header closeButton>
            <Modal.Title style={{
              color: 'rgb(70, 90, 100)',
              marginLeft: '140px'
            }}>Password Reset</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {isPwdExpired && (
              <p style={{ color: 'red', textAlign: 'center' }}>
                {pwdExpiryMsg}
              </p>
            )}
            <form onSubmit={handleReset}>
              <div className="text-center mb-3">
                <label htmlFor="newPassword" className="form-label">New Password{newPasswordError && <span style={{ color: 'red' }}> *</span>}</label>
                <input type="password" className="form-control" id="newPassword" value={newPassword}
                  onChange={(e) => {
                    setNewPassword(e.target.value);
                    setNewPasswordError(false); // Clear the error state on change
                  }} />
              </div>
              <div className="text-center mb-3">
                <label htmlFor="confirmPassword" className="form-label">Confirm New Password{confirmPasswordError && <span style={{ color: 'red' }}> *</span>}</label>
                <input type="password" className="form-control" id="confirmPassword" value={confirmPassword}
                  onChange={(e) => {
                    setConfirmPassword(e.target.value);
                    setConfirmPasswordError(false); // Clear the error state on change
                  }} />
              </div>
              <div className="text-center mb-3">
                <button className='password_reset_btn' type="submit">Set Password</button>
              </div>
            </form>
          </Modal.Body>
        </Modal>

        {showPopup && (
          <Modal style={{
            display: 'block',

          }} show={showPopup}
            backdrop="static"
            centered>
            <Modal.Header>
              <Modal.Title style={{ fontSize: "1.25rem", color: "#465a64", margin: "auto" }}>Password Expiration Warning</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {/* <p>Your password will expire soon. Please update your password.</p> */}
              <p>{pwdExpiryMsg}</p>

            </Modal.Body>
            <div className="button-container">
              <button className='ok_loginbtn' onClick={handleCloseModal}>OK</button>
              <button className='change_btn' onClick={() => { setShowPopup(false); setShowModal(true); }}>Change Password</button>
            </div>
          </Modal>
        )}
      </div>

    </>
  );
};
export default Login;
